import { render, staticRenderFns } from "./editTeams.vue?vue&type=template&id=31968ca8&"
import script from "./editTeams.vue?vue&type=script&lang=ts&"
export * from "./editTeams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports